import { OnInit, Component } from '@angular/core';

@Component({
  selector: 'app-generar-reportes-uac',
  templateUrl: './generar-reporte-UAC.component.html',
  styleUrls: ['./generar-reporte-UAC.component.scss']
})

export class GenerarReporteUACComponent implements OnInit {

  public filtroReporte: string;

  ngOnInit() {
    this.filtroReporte = '3';
  }
}
